import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { Pie, PieChart, ResponsiveContainer } from "recharts";
import TitleCase from "components/formatting/TitleCase";
import { ArcChartSettingsStateType, defaultSettings } from "./ArcChartSettings";

interface ArcChartPreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: ArcChartSettingsStateType | {};
}

export default function ArcChartPreview(props: ArcChartPreviewProps) {
  const theme = useTheme();
  const { i18n, t } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const windowHeight = window.innerHeight;
  const currentState = {...defaultSettings, ...props.settingsState};
  const textValue = t("intlNumber", {
    maximumFractionDigits: 0,
    style: "percent",
    val: .7
  });

  const dummyData = [
    { name: i18n.t("other"), value: 1000,
      fill: theme.palette.grey[300]
    },
    { name: '2', value: 500,
      fill: currentState.fillColor || theme.colors.primary.main
    }
  ];

  return (
    <Stack
      sx={{
        gap: 3,
        width: isSmallScreen ? "100%" : "50%",
        flex: 1,
        height: windowHeight < 600 ? "35vh" : "55vh"
      }}>
      {currentState.widgetTitle !== 'none' &&
        <Typography
          sx={{ fontSize: "1.2rem", textAlign: `${currentState.widgetTitleAlignment}` }}
          variant="subtitle2">
          <TitleCase text={`${currentState.widgetTitle} Title`} />
        </Typography>}
      <ResponsiveContainer>
        <PieChart>
          <Pie
            cx="50%" cy="50%"
            data={dummyData}
            dataKey="value"
            endAngle={450}
            innerRadius="60%"
            nameKey="name"
            outerRadius="90%"
            startAngle={90}
            style={{outline: "none"}} />
          <text
            dy={20}
            style={{
              fontSize: 70,
              fontWeight: "bold",
              fill: currentState.fillColor || theme.colors.primary.main
            }}
            textAnchor="middle"
            x="50%" y="50%"
          >
            {textValue}
          </text>
        </PieChart>
      </ResponsiveContainer>
    </Stack>
  );
}